import {Component, Input, OnChanges} from '@angular/core';
import {NavMenuItem} from '../../models/nav-menu-item.interface';
import {MatDialog} from '@angular/material/dialog';
import {DownloadDataDialogComponent} from '../download-data-dialog/download-data-dialog.component';
import {Router} from '@angular/router';

@Component({
  selector: 'app-lateral-menu',
  templateUrl: './lateral-menu.component.html',
  styleUrls: ['./lateral-menu.component.scss']
})
export class LateralMenuComponent implements OnChanges {

  intelligence!: boolean;
  intelligenceReporting!: boolean;

  @Input()
  submenuItems!: NavMenuItem[];
  @Input()
  showTitle!: boolean;
  @Input()
  currentUrl!: string;

  constructor(private readonly dialog: MatDialog,
              private readonly router: Router) {
  }

  ngOnChanges(): void {
    this.intelligence = this.router.url.includes('intelligence');
    this.intelligenceReporting = this.router.url.includes('intelligencereporting/forms');
  }

  openDownloadDialog(type?: string): void {
    const dialogRef = this.dialog.open(DownloadDataDialogComponent, {data: type, maxWidth: 600, width: 'inherit'} );
  }
}
